import { createAction } from '@reduxjs/toolkit';

export const setCommonState = createAction('setCommonState');
export const setUserRoles = createAction('setUserRoles');
